export default {
  loggedInUser: (username: string) => `Logged in ${username}`,
};
